import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";
import { getOrgId } from "utils/storage";

import Paths from "./paths";
import * as Types from "./types";

export const contractTypeListService = (
  params: Types.ContractTypeListRequest
) =>
  RestAPIClient.call<Types.ContractTypeListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const contractTypeListShortService = (
  params: Types.ContractTypeListRequest
) =>
  RestAPIClient.call<Types.ContractTypeListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const contractTypeCreateService = (
  params: Types.ContractTypeCreateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const contractTypeDetailService = (id: string) =>
  RestAPIClient.call<Types.ContractType>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail.replace("{OrgId}", getOrgId())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const contractTypeUpdateService = (
  params: Types.ContractTypeUpdateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update.replace("{OrgId}", getOrgId())}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
